import { IConfig } from '@cian/config/shared';

export const isReliableBuilder = (builderId: number, config: IConfig) => {
  const reliableBuilders = config.get<number[]>('countryside.reliableBuilders');

  return reliableBuilders?.includes(builderId);
};
